import styled from "styled-components";

/* 
  CSS PROPERTIES
  apperance : display an element using a platform-native styling based on the users’ operating system’s theme.
  will-change: helps browser take better decisions when a element changes properties. Increased optimization for css animations
  touch-action = mainpulation : disables double tap to zoom feature on mobile devices,removes the need for browsers to delay the generation of click events when the user taps the screen
*/

const StyledButton = styled.button`
    user-select:none;
    font-family: Raleway,sans-serif;
    font-weight: 500;
    align-items: center;
    appearance: none;
    background-color: ${props => props.active ? "rgba(45, 35, 66, 0.8)" :"#fff"};
    border-radius: ${props => props.borderRadius};
    border-width: 0;
    box-shadow:${props => props.active ? "" :"rgba(45, 35, 66, 0.2) 0 2px 4px,rgba(45, 35, 66, 0.15) 0 7px 13px -3px,rgba(214, 214, 231, 1) 0 -3px 0 inset"};
    box-sizing: border-box;
    color: ${props => props.active ? "#FFF" :"#36395A"};
    cursor: pointer;
    display: inline-flex;
    height: ${props => props.height};
    justify-content: center;
    line-height: 1;
    list-style: none;
    overflow: hidden;
    position: relative;
    text-align: left;
    text-decoration: none;
    transition: box-shadow .15s,transform .15s;
    user-select: none;
    -webkit-user-select: none;
    touch-action: manipulation;
    white-space: nowrap;
    will-change: box-shadow,transform;
    font-size: 16px;
    margin:${props => props.margin};
    width:${props => props.width};
    padding:${props => props.padding};
    &:hover:not(:disabled) {
        box-shadow: ${props => props.active ? "" :"rgba(45, 35, 66, 0.3) 0 4px 8px, rgba(45, 35, 66, 0.2) 0 7px 13px -3px, #D6D6E7 0 -3px 0 inset"};
        transform: translateY(-2px);
    }
    &:focus:not(:disabled) {
        box-shadow:${props => props.active ? "" :"#D6D6E7 0 0 0 1.5px inset, rgba(45, 35, 66, 0.4) 0 2px 4px, rgba(45, 35, 66, 0.3) 0 7px 13px -3px, #D6D6E7 0 -3px 0 inset;"}
    }
    &:active:not(:disabled) {
        box-shadow:${props => props.active ? "" :"#D6D6E7 0 3px 7px inset"};
        transform: translateY(2px);
    }
    &:disabled{
       opacity: 0.5;
       cursor: not-allowed;
    }
`;

StyledButton.defaultProps = {
    width:"max-content",
    borderRadius:"4px",
    padding:"0.3rem 0.8rem",
    height:"48px"
}

const Button = (props) => {
  return (
    <StyledButton {...props} >
        {props.children}
    </StyledButton>
  )
}


export default Button;